import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { FgPriceListRequest } from "./fg-pricelist-request";

export class FgPriceListResponseModel extends GlobalResponseObject{
    data?:FgPriceListRequest[]
     
    constructor(status:boolean, intelCode:number, internalMessage:string ,data?:FgPriceListRequest[]){
    super(status,intelCode,internalMessage)
    this.status=status
    this.intlCode=intelCode
    this.internalMessage=internalMessage
    this.data=data
    }

}